import { FormattedMessage } from "react-intl";
import { PropsWithClassName } from "../../../models/props-with-class-name";
import DateTime from "../../Shared/DateTime/DateTime";

type UserCreatedActivatedDatesProps = {
  createdAt?: string;
  activatedAt?: string;
  isUserPending?: boolean;
  dateClassName?: string;
};

const UserCreatedActivatedDates = ({
  activatedAt,
  createdAt,
  isUserPending,
  className,
  dateClassName,
}: PropsWithClassName<UserCreatedActivatedDatesProps>) => {
  return (
    <div className={`d-lg-flex align-items-center  ${className ?? ""}`}>
      <div className="w-50">
        <FormattedMessage id="USER_DETAILS.CREATED" defaultMessage="Created" />:
        <span className="mx-sm"></span>
        <b>
          <DateTime className={dateClassName}>{createdAt}</DateTime>
        </b>
      </div>
      <div className="w-50 pt-2 pt-lg-0">
        <FormattedMessage
          id="USER_DETAILS.ACTIVATED"
          defaultMessage="Activated"
        />
        :<span className="mx-sm"></span>
        {!isUserPending ? (
          <b>
            <DateTime className={dateClassName}>{activatedAt}</DateTime>
          </b>
        ) : (
          <b>
            <FormattedMessage
              id="MANAGEMENT.PENDING"
              defaultMessage="Pending"
            />
          </b>
        )}
      </div>
    </div>
  );
};

export default UserCreatedActivatedDates;
